const destinations = [
  {
    name: "Mexico (Spring Break)",
    context: "Cancun and Riviera Maya are the top international spring break destinations for PCB's massive college visitor market. Millions come to Panama City Beach each spring — and book Mexico follow-ups from home or right off the beach",
    urgency: "Mexico spring break bookings peak in January and February — standard processing cannot meet March departure dates",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Japan & South Korea (Military PCS)",
    context: "F-22 and air superiority assignments send Tyndall AFB personnel to Kadena AB Okinawa, Misawa AB, and Osan AB. Pacific assignments are premium postings for fighter pilots training at Tyndall",
    urgency: "Air Force PCS orders to Pacific assignments often arrive with 30–45 days notice — family passports must all be current",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Caribbean",
    context: "Nassau, Aruba, Jamaica, and Puerto Rico attract Panama City families looking to extend Florida sunshine into Caribbean islands. PCB's resort economy generates cruise-booking behavior during off-peak months",
    urgency: "Caribbean cruise and resort bookings from PCB often happen on 2–4 week notice during promotional windows",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Europe (NATO & Military)",
    context: "Ramstein AB, Lakenheath, and Aviano AB draw Tyndall-trained pilots and staff on European assignments. NATO exercises and air defense assignments bring Panhandle military families to Germany, UK, and Italy",
    urgency: "European military assignments come with 30–45 day report windows that require pre-travel passport processing",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Bahamas",
    context: "Nassau and the Out Islands attract PCB's offshore fishing and boating community. Direct water access via the Gulf and Florida Straits makes Bahamas runs a natural extension of the area's marine recreation culture",
    urgency: "Private boat Bahamas crossings require passports for all passengers at Bahamian customs clearance",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Canada & United Kingdom",
    context: "Toronto, Ottawa, and London draw Panama City construction and disaster recovery industry professionals for insurance conferences, equipment vendor meetings, and industry events following the Hurricane Michael rebuild",
    urgency: "Industry conference bookings often confirm 2–3 weeks before the event — passport validity is rarely checked first",
    icon: "ri-map-pin-2-line",
  },
];

const stats = [
  { stat: "55%", label: "of Panama City expedited requests involve spring break bookings, Tyndall PCS orders, or Gulf Coast marine travel" },
  { stat: "5+ Hours", label: "round-trip driving time to the Atlanta Passport Agency — the only regional option for Panama City" },
  { stat: "Mar–Apr", label: "peak spring break season that drives January–February passport urgency from Panhandle travelers" },
  { stat: "30 Days", label: "typical Tyndall AFB PCS order notice — barely enough for standard processing even if applied immediately" },
];

export default function PanamaCityDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Panama City Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            From Tyndall F-22 pilot PCS orders to spring break Mexico trips and offshore Bahamas fishing runs, Panama City's passport demand reflects its identity as a military community, Gulf resort destination, and Panhandle travel hub with no nearby passport agency.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Florida Panhandle Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across the Florida Panhandle and Emerald Coast with the same expedited passport expertise.
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              <a href="/pensacola" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Pensacola <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/tallahassee" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Tallahassee <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/upper-grand-lagoon" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Upper Grand Lagoon <i className="ri-arrow-right-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}